import { render, staticRenderFns } from "./FileResource.vue?vue&type=template&id=3b3fa386&scoped=true"
import script from "./FileResource.vue?vue&type=script&lang=js"
export * from "./FileResource.vue?vue&type=script&lang=js"
import style0 from "./FileResource.vue?vue&type=style&index=0&id=3b3fa386&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3fa386",
  null
  
)

export default component.exports